import { DividerPassThrough } from "primeng/types/divider";

export const dividerPtOptions: DividerPassThrough = {
    root: {
        class: "mb-0",
    },
};
